import { HOURS } from './data';
// RESERVER — booking form on parchment
export default function Reserver() {
  return (
    <div className="bg-[#F1ECDF] text-[#0A0A0A]">
      <section className="pt-12 pb-8 max-w-[1300px] mx-auto px-8 lg:px-14 border-b-2 border-[#0A0A0A]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D4A] mb-4">— Acte IV / Réserver</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.95] text-[#4A5638]">Une <span className="italic text-[#6B2D4A]" style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>table</span> pour vous.</h1>
      </section>

      <section className="max-w-[1300px] mx-auto px-8 lg:px-14 py-16 grid lg:grid-cols-[1fr_1.4fr] gap-12">
        <aside>
          <div className="border-l-4 border-[#6B2D4A] pl-6">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D4A]">À table</p>
            <p className="font-serif italic text-3xl text-[#4A5638] mt-2">14 rue d'Italie</p>
            <p className="text-sm text-[#0A0A0A]/65 mt-2 leading-[1.7]">13100 Aix-en-Provence<br />+33 4 42 555 0184</p>
          </div>
          <div className="mt-8">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D4A] mb-3">Hours</p>
            <table className="w-full text-sm">
              <tbody>{HOURS.map(([d, h]) => (<tr key={d} className="border-b border-dashed border-[#0A0A0A]/20"><td className="py-2 font-serif italic">{d}</td><td className="py-2 text-right text-[#0A0A0A]/65 font-mono text-[10px]">{h}</td></tr>))}</tbody>
            </table>
          </div>
        </aside>

        <form className="bg-[#FAF6E8] border border-[#0A0A0A]/15 p-8 lg:p-12 space-y-6 relative" onSubmit={(e) => e.preventDefault()} style={{boxShadow:'2px 4px 0 rgba(107,45,74,0.15)'}}>
          <div className="border-b-2 border-[#6B2D4A] pb-3 flex items-baseline justify-between">
            <span className="font-serif italic text-2xl text-[#6B2D4A]" style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>Une table, s'il vous plaît</span>
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#0A0A0A]/45">№ TBL-2026</span>
          </div>
          <Field label="Votre nom" testId="resto-res-name" />
          <div className="grid sm:grid-cols-2 gap-5">
            <Field label="Téléphone" type="tel" testId="resto-res-tel" />
            <Field label="Email" type="email" testId="resto-res-email" />
          </div>
          <div className="grid sm:grid-cols-3 gap-5">
            <Field label="Date" type="date" testId="resto-res-date" />
            <SelectField label="Heure" testId="resto-res-time" options={['12:00', '12:30', '13:00', '19:30', '20:00', '20:30', '21:00']} />
            <SelectField label="Couverts" testId="resto-res-cov" options={['1', '2', '3', '4', '5', '6', '7', '8 ou plus']} />
          </div>
          <div>
            <label className="font-serif italic text-base text-[#6B2D4A] block mb-2">Une note pour Léa</label>
            <textarea data-testid="resto-res-note" rows="4" placeholder="Allergies · anniversaire · table près de la fenêtre…" className="w-full bg-transparent border-b-2 border-[#0A0A0A]/25 py-2.5 outline-none focus:border-[#6B2D4A] resize-none font-serif text-base text-[#0A0A0A] placeholder:text-[#0A0A0A]/30" />
          </div>
          <p className="font-serif italic text-sm text-[#0A0A0A]/60 border-t border-dashed border-[#0A0A0A]/15 pt-4">Léa vous confirmera dans l'heure. Si urgent, appelez-nous directement.</p>
          <button type="button" data-testid="resto-res-submit" className="bg-[#6B2D4A] text-[#F1ECDF] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#4A5638] transition-colors">Envoyer la demande →</button>
        </form>
      </section>
    </div>
  );
}
function Field({ label, type = 'text', testId }) {
  return (
    <div>
      <label className="font-serif italic text-base text-[#6B2D4A] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b-2 border-[#0A0A0A]/25 py-2.5 outline-none focus:border-[#6B2D4A] font-serif text-base text-[#0A0A0A]" />
    </div>
  );
}
function SelectField({ label, options, testId }) {
  return (
    <div>
      <label className="font-serif italic text-base text-[#6B2D4A] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-transparent border-b-2 border-[#0A0A0A]/25 py-2.5 outline-none focus:border-[#6B2D4A] font-serif text-base text-[#0A0A0A]">
        {options.map(o => <option key={o}>{o}</option>)}
      </select>
    </div>
  );
}
